var React = require('react');

function Boot (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 448v32l32 32h64l32-32 32 32h64l32-32 32 32h64l32-32 32 32h64l32-32v-32zM352 80V16a16 16 0 0 0-16-16H16A16 16 0 0 0 0 16v80h336a16 16 0 0 0 16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M439.3 285.8L320 256h-56a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h56v-32h-56a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8h56v-32H0v288h512v-37a96.07 96.07 0 0 0-72.7-93.2z","className":"fa-primary","key":2})]);
}

Boot.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Boot;

Boot.default = Boot;
